import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { OneLakeFilesLocation } from 'shell-models-lib';
import { FileLocationAdapter } from './file-location.adapter';

@AdapterRegistry.adapter({ model: Metamodel.modelFor(OneLakeFilesLocation) })
export class OneLakeFileLocationAdapter extends FileLocationAdapter<OneLakeFilesLocation, Model.DatasetLocation> {
    public _toResource(store: OneLakeFilesLocation): Model.OneLakeFilesLocation {
        return {
            type: OneLakeFilesLocation.MODEL.name,
            fileName: ValueAdapter.toResource(store, OneLakeFilesLocation.FILE_NAME) || undefined,
            folderPath: ValueAdapter.toResource(store, OneLakeFilesLocation.FOLDER_PATH) || undefined
        };
    }

    public _toModel(resource: Model.OneLakeFilesLocation, owner: Named): OneLakeFilesLocation {
        const model = Owned.create<OneLakeFilesLocation>(OneLakeFilesLocation.MODEL, owner);
        ValueAdapter.toModel(model, OneLakeFilesLocation.FILE_NAME, resource.fileName);
        ValueAdapter.toModel(model, OneLakeFilesLocation.FOLDER_PATH, resource.folderPath);
        return model;
    }
}
